import React, { FC } from 'react';
import TilesDetails from '../atoms/TilesDetails';
import Spinner from '../atoms/Spinner';
import { useNavigate } from 'react-router-dom';

interface props {
  id: number;
  title: string;
  description: string;
  phase?:number
}

interface TilesDetailsListProps {
  tiles: props[];
  loading: boolean
  onDelete: (id: number) => void
  category: string;
}

const TilesDetailsList: FC<TilesDetailsListProps> = ({ tiles, category, loading, onDelete }) => {
 const navigate = useNavigate();
  const isAiSpace = category === "knowledge-hubs";
  const isAiCrew = category === "crews";
  const handleClick = (id:number) => {
    if (isAiSpace) {
      navigate(`/space/${id}`);
    } else if (isAiCrew) {
      navigate(`/edit_crew/${id}`);
    }
  };
  return (

    <>
      {loading ? (
        <Spinner />
      ) : tiles.length > 0 ? (
        <div className="pt-0 All_crews_space_tils mb-3">
          {tiles.map((tile) => (
            <div className="assigned_tiles_space h-100" key={tile.id}>
              <div style={{ cursor: "pointer" }} onClick={()=>handleClick(tile.id)} className={category === 'crews'? `assigned_tiles_crews d-flex flex-column h-100 p-3 pt-2`:`assigned_tiles_space d-flex flex-column h-100 p-3 pt-2`}>
                <TilesDetails
                  id={tile.id}
                  title={tile.title}
                  phase={tile.phase}
                  description={tile.description}
                  category={category}
                  onDelete={onDelete}
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="col-12 text-center">
          <p>{`No ${category.replace('-', ' ')} are  available.`}</p>
        </div>
      )}
    </>

  );
};


export default TilesDetailsList;
